/**
 * Driver Trip Detail DSL — detail view + status action configuration.
 */

import type { ViewTemplateDSL } from '@/lib/use-view-template';
import { STATUS_ACTIONS } from './driver-config';

export const TRIP_DETAIL_DSL: ViewTemplateDSL = {
  sections: [
    {
      title: 'Trip Info',
      columns: 2,
      fields: [
        { field: 'jobNo',         label: 'Job',        span: 1 },
        { field: 'customerName',  label: 'Customer',   span: 1 },
        { field: 'vehicleNo',    label: 'Vehicle',     span: 1 },
        { field: 'scheduledDate', label: 'Scheduled',  span: 1, format: 'date' },
      ],
    },
  ],
  statusActions: STATUS_ACTIONS,
};
